/**
 * 履约管理 - 公共打印接口
 */
import request from '@/utils/http';
const otpBaseUrl = '/api-antms/transport';

// 发车单打印
export const dispatchPrint = data => {
    return request({
        url: `/api-antms/common/print/dispatch`,
        method: 'post',
        data
    });
};

// 出库单打印
export const outboundPrint = data => {
    return request({
        url: `/api-antms/common/print/outbound`,
        method: 'post',
        data
    });
};

// 移交单打印
export const transferPrint = data => {
    return request({
        url: `${otpBaseUrl}/print/transfer`,
        method: 'post',
        data
    });
};

// 配送单奈雪\奈雪2B打印
export const naixuePrint = data => {
    return request({
        url: `/api-antms/common/print/naixue`,
        method: 'get',
        params: data,
        responseType: 'blob'
    });
};

// 运输协议打印
export const protocolPrint = data => {
    return request({
        url: `/api-antms/common/print/protocol`,
        method: 'get',
        params: data,
        responseType: 'blob'
    });
};

// 蓝月亮打印
export const bluemoonPrint = data => {
    return request({
        url: `/api-antms/common/print/bluemoon`,
        method: 'get',
        params: data
    });
};

// 更新打印次数
export const updatePrintCount = data => {
    return request({
        url: `/api-antms/common/print/update`,
        method: 'post',
        data
    });
};

// 打印提货单限制
export const checkPickupPrint = data => {
    return request({
        url: `/api-antms/transport/print/checkPickupPrint`,
        method: 'get',
        params: data
    });
};
